import React from "react";
import { Box, Container, Typography, Grid, Button } from "@mui/material";
import { motion } from "framer-motion";
import BRAND from "../theme/talktokam";

const openRoles = [
  { title: "Full Stack Developer", dept: "Engineering", loc: "Remote", type: "Full-time", emoji: "?????" },
  { title: "Product Designer", dept: "Design", loc: "Remote", type: "Full-time", emoji: "??" },
  { title: "Customer Success Manager", dept: "Success", loc: "Remote", type: "Full-time", emoji: "??" },
  { title: "Sales & Marketing Lead", dept: "Growth", loc: "Remote", type: "Full-time", emoji: "??" },
];

const Careers = () => {
  return (
    <Box sx={{ background: "#050816", minHeight: "100vh" }}>
      <Box sx={{ position: "relative", textAlign: "center", py: { xs: 10, md: 14 }, background: `radial-gradient(ellipse 800px 600px at 20% 10%, ${BRAND.cyan}33 0%, transparent 60%), radial-gradient(ellipse 700px 500px at 85% 90%, ${BRAND.purple}33 0%, transparent 60%), radial-gradient(ellipse 600px 400px at 50% 50%, ${BRAND.primary}1a 0%, transparent 60%), linear-gradient(180deg, #050816 0%, #0a0e27 50%, #050816 100%)`, overflow: "hidden" }}>
        <Box sx={{ position: "absolute", inset: 0, backgroundImage: `linear-gradient(rgba(56,189,248,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(56,189,248,0.04) 1px, transparent 1px)`, backgroundSize: "60px 60px", maskImage: "radial-gradient(ellipse at center, black 30%, transparent 70%)", WebkitMaskImage: "radial-gradient(ellipse at center, black 30%, transparent 70%)", pointerEvents: "none" }} />
        <motion.div
          animate={{ y: [0, -40, 0], scale: [1, 1.1, 1] }}
          transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
          style={{ position: "absolute", top: "5%", left: "-5%", width: 500, height: 500, borderRadius: "50%", background: `radial-gradient(circle, ${BRAND.cyan}40 0%, transparent 70%)`, filter: "blur(60px)", pointerEvents: "none" }}
        />
        <motion.div
          animate={{ y: [0, 40, 0], scale: [1, 1.15, 1] }}
          transition={{ duration: 16, repeat: Infinity, ease: "easeInOut" }}
          style={{ position: "absolute", bottom: "-10%", right: "-10%", width: 600, height: 600, borderRadius: "50%", background: `radial-gradient(circle, ${BRAND.purple}40 0%, transparent 70%)`, filter: "blur(80px)", pointerEvents: "none" }}
        />
        <motion.div
          animate={{ y: [0, -25, 0], x: [0, 20, 0] }}
          transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
          style={{ position: "absolute", top: "50%", right: "30%", width: 300, height: 300, borderRadius: "50%", background: `radial-gradient(circle, ${BRAND.primary}26 0%, transparent 70%)`, filter: "blur(40px)", pointerEvents: "none" }}
        />
        <Container maxWidth="md" sx={{ position: "relative", zIndex: 1 }}>
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <Typography variant="h2" sx={{ fontWeight: 800, fontSize: { xs: "2rem", md: "3rem" }, background: "linear-gradient(135deg, #38bdf8, #a855f7)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", mb: 2 }}>
              💼 Join the Team Building the Future of Conversations
            </Typography>
            <Typography sx={{ fontSize: "1.1rem", color: "#94a3b8", maxWidth: 550, mx: "auto" }}>
              We're on a mission to make conversational AI accessible to every business. Come build with us.
            </Typography>
          </motion.div>
        </Container>
      </Box>

      <Container sx={{ py: { xs: 6, md: 10 } }}>
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <Box sx={{ maxWidth: 700, mx: "auto", textAlign: "center", mb: 6 }}>
            <Typography sx={{ fontWeight: 700, fontSize: "1.5rem", background: "linear-gradient(135deg, #38bdf8, #a855f7)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", mb: 3 }}>Why Talktokam?</Typography>
            <Grid container spacing={2}>
              {[
                { icon: "??", text: "Work remotely from anywhere" },
                { icon: "??", text: "Competitive salary & equity" },
                { icon: "??", text: "Ship fast, make an impact" },
                { icon: "??", text: "Learning & development budget" },
                { icon: "???", text: "Flexible vacation policy" },
                { icon: "??", text: "Latest tools & equipment" },
              ].map((item, i) => (
                <Grid item xs={6} sm={4} key={i}>
                  <Box sx={{ p: 2, borderRadius: 3, bgcolor: "rgba(255,255,255,0.05)", backdropFilter: "blur(12px)", border: "1px solid rgba(255,255,255,0.08)", textAlign: "center", height: "100%", transition: "all 0.3s", "&:hover": { transform: "translateY(-4px)", borderColor: "rgba(56,189,248,0.3)", boxShadow: "0 12px 40px rgba(56,189,248,0.1)" } }}>
                    <Typography sx={{ fontSize: "1.5rem", mb: 0.5 }}>{item.icon}</Typography>
                    <Typography sx={{ fontSize: "0.85rem", color: "#cbd5e1", fontWeight: 600 }}>{item.text}</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </motion.div>

        <Typography sx={{ fontWeight: 700, fontSize: "1.3rem", background: "linear-gradient(135deg, #38bdf8, #a855f7)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", mb: 3 }}>Open Roles</Typography>
        <Grid container spacing={3}>
          {openRoles.map((role, i) => (
            <Grid item xs={12} sm={6} key={i}>
              <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.05 }}>
                <Box sx={{ p: 3, borderRadius: 4, bgcolor: "rgba(255,255,255,0.05)", backdropFilter: "blur(16px)", border: "1px solid rgba(255,255,255,0.08)", display: "flex", gap: 2, alignItems: "center", transition: "all 0.3s", "&:hover": { borderColor: "rgba(56,189,248,0.3)", transform: "translateY(-2px)", boxShadow: "0 12px 40px rgba(56,189,248,0.1)" } }}>
                  <Typography sx={{ fontSize: "2rem" }}>{role.emoji}</Typography>
                  <Box sx={{ flex: 1 }}>
                    <Typography sx={{ fontWeight: 700, fontSize: "1rem", color: "#fff" }}>{role.title}</Typography>
                    <Typography sx={{ fontSize: "0.8rem", color: "#94a3b8" }}>{role.dept} � {role.loc} � {role.type}</Typography>
                  </Box>
                  <Button variant="outlined" size="small" sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, borderColor: "rgba(99,102,241,0.5)", color: "#6366f1", flexShrink: 0, "&:hover": { borderColor: "#6366f1", bgcolor: "rgba(99,102,241,0.1)" } }}>
                    Apply
                  </Button>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ textAlign: "center", mt: 6, p: { xs: 3, md: 4 }, borderRadius: 4, bgcolor: "rgba(255,255,255,0.05)", backdropFilter: "blur(16px)", border: "1px solid rgba(255,255,255,0.08)", transition: "all 0.3s", "&:hover": { borderColor: "rgba(56,189,248,0.3)", boxShadow: "0 12px 40px rgba(56,189,248,0.1)" } }}>
          <Typography sx={{ fontWeight: 700, fontSize: "1.1rem", color: "#fff", mb: 1 }}>Don't see the right role?</Typography>
          <Typography sx={{ color: "#94a3b8", mb: 2 }}>Send your resume to careers@talktokam.app</Typography>
          <Button variant="contained" onClick={() => window.location.href = "mailto:careers@talktokam.app"} sx={{ borderRadius: "10px", textTransform: "none", fontWeight: 700, background: "linear-gradient(135deg, #4F46E5, #7C3AED)", boxShadow: "0 4px 15px rgba(79,70,229,0.4)", "&:hover": { boxShadow: "0 6px 25px rgba(79,70,229,0.6)" } }}>
            Email Us
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Careers;
